let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const scrollToId = (id, offset = 0) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};
